// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_jw-1";
export var rowFirst = "_jw-3";
export var rowLast = "_jw-5";
export var rowMiddle = "_jw-4";
export var ticketListScroll = "_jw-2";
export var ticketStack = "_jw-0";